/*
							!IMPORTANT!
	This is the copy of @ng-select/ng-select npm package.
	Version: 1.6.3.
	Link to the original library code: https://github.com/ng-select/ng-select


	Select 1.x have some issues which was resolved in later library version, but we cannot upgrade.
	Studio Ninja could only support library version 1.x. Version >= 2.x are incompatible.
	This is because we have Ionic 3.x which supports only Angular up to 5.x version.

	Here is the links for original revealed issues: https://studioninjacrm.atlassian.net/browse/SN-5512; https://studioninjacrm.atlassian.net/browse/SN-5506;
	So there were a decision made to copy library and fix the issues from the inside.
	Later if Ninja will have Ionic and Angular versions updated, this library could be removed and should be added as npm package from original source.
 */

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
	NgSelectComponent,
	NG_SELECT_DEFAULT_CONFIG
} from './ng-select.component';
import {
	NgOptionTemplateDirective,
	NgLabelTemplateDirective,
	NgHeaderTemplateDirective,
	NgFooterTemplateDirective,
	NgOptgroupTemplateDirective,
	NgNotFoundTemplateDirective,
	NgTypeToSearchTemplateDirective,
	NgLoadingTextTemplateDirective,
	NgMultiLabelTemplateDirective,
	NgTagTemplateDirective
} from './ng-templates.directive';
import { NgOptionComponent } from './ng-option.component';
import { NgOptionHighlightDirective } from './ng-option-highlight.directive';
import { NgDropdownPanelComponent } from './ng-dropdown-panel.component';
import { WindowService } from './window.service';
import { VirtualScrollService } from './virtual-scroll.service';
import { ConsoleService } from './console.service';

// @ts-ignore
@NgModule({
	declarations: [
		NgDropdownPanelComponent,
		NgOptionComponent,
		NgSelectComponent,
		NgOptionHighlightDirective,
		NgOptgroupTemplateDirective,
		NgOptionTemplateDirective,
		NgLabelTemplateDirective,
		NgMultiLabelTemplateDirective,
		NgHeaderTemplateDirective,
		NgFooterTemplateDirective,
		NgNotFoundTemplateDirective,
		NgTypeToSearchTemplateDirective,
		NgLoadingTextTemplateDirective,
		NgTagTemplateDirective
	],
	imports: [CommonModule],
	exports: [
		NgSelectComponent,
		NgOptionComponent,
		NgOptionHighlightDirective,
		NgOptgroupTemplateDirective,
		NgOptionTemplateDirective,
		NgLabelTemplateDirective,
		NgMultiLabelTemplateDirective,
		NgHeaderTemplateDirective,
		NgFooterTemplateDirective,
		NgNotFoundTemplateDirective,
		NgTypeToSearchTemplateDirective,
		NgLoadingTextTemplateDirective,
		NgTagTemplateDirective
	],
	providers: [
		ConsoleService,
		WindowService,
		VirtualScrollService,
		{
			provide: NG_SELECT_DEFAULT_CONFIG,
			useValue: {
				notFoundText: 'No items found',
				typeToSearchText: 'Type to search',
				addTagText: 'Add item',
				loadingText: 'Loading...',
				clearAllText: 'Clear all',
				disableVirtualScroll: false
			}
		}
	]
})
export class NgSelectModule {}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./shared/libs/@ng-select/ng-select/ng-select.module.ts